import { authReducer, initialState } from './auth-reducer';
export const createAuthStoreInitializer = () => (set) => ({
    state: initialState,
    dispatch: (args) => set((state) => (Object.assign(Object.assign({}, state), { state: authReducer(state.state, args) }))),
});
//# sourceMappingURL=auth-store.initializer.js.map